export const languageName: any = {
  en: 'English',
  zh: '繁體中文',
  ja: '日本語',
  ko: '한국어',
  vn: 'Việt Nam',
  id: 'Indonesia',
  th: 'ภาษาไทย',
  pt: 'Português'
  // es: 'Español'
}

export const languageShortName: any = {
  en: 'En',
  zh: '繁中',
  ja: '日本語',
  ko: '한국어',
  vn: 'Việt Nam',
  id: 'Indonesia',
  th: 'ภาษาไทย',
  pt: 'Português'
  // es: 'Español'
}

// export const validLanguages: any = [`en`, `zh`, `ja`, `ko`, `vn`, `id`, `th`, 'pt', 'es']
export const validLanguages: any = [`en`, `zh`, `ja`, `ko`, `vn`, `id`, `th`, 'pt']
